import React, { useEffect, useState } from 'react';
import { Card, Table, Divider } from '@scuf/common';
import { useTranslation } from 'react-i18next';
import { RMAMANUFATURA, notificationAtom } from 'resources';
import { EventoTransicao } from 'models/rmamanufatura/detailsRma';
import useFetch from 'helpers/hooks/useFetch';
import { formatDateDiaMesAnoHoraMinuto } from 'helpers';
import { useSetRecoilState } from 'recoil';

interface ControleDeFluxoProps {
    rmaId: number;
}

const ControleDeFluxo: React.FC<ControleDeFluxoProps> = ({ rmaId }) => {
    const { t } = useTranslation(['rmamanufatura', 'common']);
    const [loading, setLoading] = useState(false);
    const setNotification = useSetRecoilState(notificationAtom);

    const [eventTransition, getEventTransition] = useFetch<{ rmaId: number }>({
        url: RMAMANUFATURA.eventTransition,
        method: 'GET'
    });

    useEffect(() => {
        try {
            getEventTransition({ rmaId: rmaId });
        } catch {
            setNotification(old => ({ ...old, message: t('common:errors.ErroEvento') }));
        }
    }, [rmaId]);

    function formatFirstLetterUpper(str: string) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    return (
        <Card>
            <Card.Content>
                <h2>{t('rmamanufatura:translation.FlowControl')}</h2>
                <Divider />
                <Table loading={loading}>
                    <Table.Header>
                        <Table.HeaderCell content={t('common:translation.Status')} />
                        <Table.HeaderCell content="SSO ID" />
                        <Table.HeaderCell content={t('rmamanufatura:translation.Situation')} />
                        <Table.HeaderCell content={t('rmamanufatura:translation.Observation')} />
                        <Table.HeaderCell content={t('common:translation.DateBR')} />
                    </Table.Header>
                    <Table.Body>
                        {eventTransition?.data?.map((transicao: EventoTransicao, idx: number) => (
                            <Table.Row key={idx}>
                                <Table.Cell>{transicao.status}</Table.Cell>
                                <Table.Cell>{transicao.ssoId}</Table.Cell>
                                <Table.Cell>{formatFirstLetterUpper(transicao.situacao)}</Table.Cell>
                                <Table.Cell>{transicao.observacao}</Table.Cell>
                                <Table.Cell>{formatDateDiaMesAnoHoraMinuto(transicao.updatedAt.toLocaleString())}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
                {(!eventTransition?.data || eventTransition.data.length === 0) && !loading && (
                    <div style={{ marginTop: 16, color: '#888' }}>{t('rmamanufatura:translation.NoTransitionsFound')}</div>
                )}
            </Card.Content>
        </Card>
    );
};

export default ControleDeFluxo;
